import { useSelector } from "react-redux";

import { selectSelectedWireImportBatch } from "./selectors";

export const useSelectedWireImportBatch = () => {
  return useSelector(selectSelectedWireImportBatch);
};
